module.exports = {"361130001":"蚺城街道","361130100":"紫阳镇","361130101":"清华镇","361130102":"秋口镇","361130103":"江湾镇","361130104":"思口镇","361130106":"赋春镇","361130107":"镇头镇","361130109":"太白镇","361130110":"中云镇","361130111":"许村镇","361130200":"溪头乡","361130201":"段莘乡","361130204":"浙源乡","361130205":"沱川乡","361130206":"大鄣山乡","361130208":"珍珠山乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/361130.json
// module id = 1464
// module chunks = 0